import React, { useEffect, useState } from "react";

import { useRecoilValue } from "recoil";
import { userState } from "../Services/RecoilAtoms";
import {
  AdminDeleteAProduct,
  AdminViewAllProducts,
} from "../utils/Api/ApiCalls";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

const ProductGrid = () => {
  const currentUser = useRecoilValue(userState);
  const [productData, setProductData] = useState([]);

  const fetchAdminProducts = async () => {
    try {
      const response = await AdminViewAllProducts(currentUser?.data?.info?.id);
      setProductData(response.data);
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  const RemovingSingleProduct = async (id) => {
    try {
      const response = await AdminDeleteAProduct(id);
      Swal.fire({
        title: "Product Deleted Successfully",
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    } catch (err) {
    Swal.fire({ icon: "error", title: "Error", text: err?.response?.data?.message || err?.message || "An error occurred" });
    return err;
  }
  };

  useEffect(() => {
    fetchAdminProducts();
  }, []);
  return (
    <section class="content-main">
      <div class="content-header">
        <div>
          <h2 class="content-title card-title">Products grid</h2>
          <p>Lorem ipsum dolor sit amet.</p>
        </div>
        <div>
          <a href="#" class="btn btn-light rounded font-md">
            Export
          </a>
          <a href="#" class="btn btn-light rounded font-md">
            Import
          </a>
          <a href="/add-product" class="btn btn-primary btn-sm rounded">
            Create new
          </a>
        </div>
      </div>
      <div class="card mb-4">
        <header class="card-header">
          <div class="row gx-3">
            <div class="col-lg-4 col-md-6 me-auto">
              <input type="text" placeholder="Search..." class="form-control" />
            </div>
            <div class="col-lg-2 col-6 col-md-3">
              <select class="form-select">
                <option>All category</option>
                <option>Electronics</option>
                <option>Clothings</option>
                <option>Something else</option>
              </select>
            </div>
            <div class="col-lg-2 col-6 col-md-3">
              <select class="form-select">
                <option>Latest added</option>
                <option>Cheap first</option>
                <option>Most viewed</option>
              </select>
            </div>
          </div>
        </header>

        <div class="card-body">
          <div class="row gx-3 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 row-cols-xxl-5">
          {
            productData?.map((props)=>(
                <div class="col">
                <div class="card card-product-grid">
                  <a href="#" class="img-wrap">
                    <img src="assets/imgs/items/1.jpg" alt="Product" />
                  </a>
                  <div class="info-wrap">
                    <a href="#" class="title text-truncate">
                      {props?.productTitle}
                    </a>
                    <div class="price mb-2">#{props?.regularPrice}</div>
  
                    <Link to = {`/edit-product/${props?.id}`}>
                    <a href="#" class="btn btn-sm font-sm rounded btn-brand">
                      <i class="material-icons md-edit"></i> Edit
                    </a>
                    </Link>
                    <a 
                     onClick={() => {
                        RemovingSingleProduct(props.id);
                      }}
                    href="#" class="btn btn-sm font-sm btn-light rounded">
                      <i class="material-icons md-delete_forever"></i> Delete
                    </a>
                  </div>
                </div>
              </div>
  
            ))
          }
           
          </div>
        </div>
      </div>

      <div class="pagination-area mt-30 mb-50">
        <nav aria-label="Page navigation example">
          <ul class="pagination justify-content-start">
            <li class="page-item active">
              <a class="page-link" href="#">
                01
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" href="#">
                02
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" href="#">
                03
              </a>
            </li>
            <li class="page-item">
              <a class="page-link dot" href="#">
                ...
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" href="#">
                16
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" href="#">
                <i class="material-icons md-chevron_right"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </section>
  );
};

export default ProductGrid;
